import { ViewId } from '@/lib/permissions';

export interface ViewMeta {
  id: ViewId;
  title: string;
  subtitle: string;
  keywords: string[];
  shortcut?: string;
}

export const VIEW_LIST: ViewMeta[] = [
  {
    id: 'dashboard',
    title: 'ภาพรวมระบบ',
    subtitle: 'สถิติและข้อมูลภาพรวมของระบบทั้งหมด',
    keywords: ['dashboard', 'แดชบอร์ด', 'ภาพรวม', 'home'],
    shortcut: 'G D',
  },
  {
    id: 'calendar',
    title: 'ปฏิทินทีม',
    subtitle: 'ตารางการประชุมและนัดหมายกิจกรรม',
    keywords: ['calendar', 'ปฏิทิน', 'event', 'นัดหมาย'],
    shortcut: 'G C',
  },
  {
    id: 'server',
    title: 'จัดการทีมงาน & เซิร์ฟเวอร์',
    subtitle: 'ข้อมูลทีมงาน บทบาทหน้าที่ และส่วนแบ่งเปอร์เซ็นรายได้',
    keywords: ['server', 'staff', 'ทีม', 'team', 'ปันผล'],
    shortcut: 'G S',
  },
  {
    id: 'project',
    title: 'โปรเจกต์ (Projects)',
    subtitle: 'จัดการงานแยกตามโปรเจกต์ วางแผนและติดตามความคืบหน้า',
    keywords: ['project', 'projects', 'โปรเจกต์', 'งาน', 'board'],
    shortcut: 'G K',
  },
  {
    id: 'habits',
    title: 'งานของฉัน (Task)',
    subtitle: 'กำหนดงานที่ต้องทำของตัวเอง แยกหมวดหมู่และวางไทมไลน์',
    keywords: ['task', 'my tasks', 'งานของฉัน', 'todo'],
    shortcut: 'G T',
  },
  {
    id: 'finance',
    title: 'การเงิน & ปันผล',
    subtitle: 'ระบบจัดการรายรับรายจ่ายและการหารายได้',
    keywords: ['finance', 'money', 'การเงิน', 'รายรับ', 'รายจ่าย'],
    shortcut: 'G F',
  },
  {
    id: 'images',
    title: 'ฝากรูป & ตัดต่อ (CDN)',
    subtitle: 'ระบบย่อและฝากรูปภาพความเร็วสูง',
    keywords: ['image', 'cdn', 'รูป', 'upload'],
    shortcut: 'G I',
  },
  {
    id: 'changelog',
    title: 'อัปเดตและแพตช์โน้ต',
    subtitle: 'ประวัติการอัปเดตระบบและการแก้ไข',
    keywords: ['changelog', 'patch', 'อัปเดต', 'แพตช์'],
    shortcut: 'G L',
  },
  {
    id: 'settings',
    title: 'การตั้งค่าระบบ',
    subtitle: 'ตั้งค่าทั่วไป การแจ้งเตือน และจัดการบุคลากร',
    keywords: ['settings', 'ตั้งค่า', 'config'],
    shortcut: 'G ,',
  },
  {
    id: 'audit',
    title: 'Audit Log (ประวัติ)',
    subtitle: 'บันทึกการกระทำทั้งหมดในระบบ',
    keywords: ['audit', 'log', 'ประวัติ'],
    shortcut: 'G A',
  },
];

export const VIEW_MAP = Object.fromEntries(VIEW_LIST.map((v) => [v.id, v])) as Record<ViewId, ViewMeta>;

const VALID_VIEWS = new Set<string>(VIEW_LIST.map((v) => v.id));

export function parseViewParam(value: string | null | undefined): ViewId {
  // Legacy URL ?view=kanban → project
  if (value === 'kanban') return 'project';
  if (value && VALID_VIEWS.has(value)) return value as ViewId;
  return 'dashboard';
}

export function viewToUrl(view: ViewId): string {
  if (view === 'dashboard') return '/';
  return `/?view=${view}`;
}
